import { computed } from 'vue'
import { useStore } from 'vuex'
import { Actions } from '@/store/enums/StoreEnums'

/**
 * Composable pour gérer le connectAs
 */
export function useConnectAs () {
  const store = useStore()

  /**
   * Vérifie si l'utilisateur est actuellement en mode connectAs
   */
  const isConnectedAs = computed(() => store.getters.isConnectedAs)

  /**
   * Récupère les informations de l'utilisateur original
   */
  const originalUser = computed(() => store.getters.getOriginalUser)

  /**
   * Récupère l'utilisateur actuel
   */
  const currentUser = computed(() => store.getters.getUser)

  /**
   * Se connecter en tant qu'un autre utilisateur
   * @param targetUserId - ID de l'utilisateur cible
   * @param targetUserType - Type de l'utilisateur cible (student, faculty, staff)
   * @param service - Service optionnel à accéder
   */
  const connectAs = async (
    targetUserId: number,
    targetUserType: string,
    service?: string
  ) => {
    try {
      return await store.dispatch(Actions.CONNECT_AS_USER, {
        targetUserId,
        targetUserType,
        service
      })
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Erreur lors de la connexion en tant qu\'autre utilisateur'
      throw new Error(message)
    }
  }

  /**
   * Quitter le mode connectAs et revenir à l'utilisateur original
   */
  const exitConnectAs = async () => {
    try {
      await store.dispatch(Actions.EXIT_CONNECT_AS)
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Erreur lors de la sortie du mode connectAs'
      throw new Error(message)
    }
  }

  return {
    isConnectedAs,
    originalUser,
    currentUser,
    connectAs,
    exitConnectAs
  }
}
